import React from 'react';

import style from './styles.module.scss';

export default function SvgTint({
    dark
}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className={`${style.svg} ${dark ? style['svg--dark'] : ''}`}>
            <g fillRule="evenodd">
                <path d="M9.167 0C6.649 0 4.583 2.066 4.583 4.583v1.834l1.834-1.834c0-1.518 1.231-2.75 2.75-2.75 1.518 0 2.75 1.232 2.75 2.75v6.961c0 .093.007.2-.086.2-.093.277-.19.448-.373.631-.551.551-1.368.551-1.919 0-.551-.551-.551-1.368 0-1.92.365-.365.91-.468 1.461-.286V5.872L9.08 3.84.173 12.747c-.552.552 1.106 3.026 3.58 5.5 2.475 2.475 4.95 4.133 5.5 3.581l8.91-8.909-4.412-4.325v-4.01C13.75 2.065 11.684 0 9.167 0zm6.416 9.167l3.667 3.666v5.959c0 .734.641 1.375 1.375 1.375S22 19.526 22 18.792c0-2.385-.365-7.792-6.417-9.625z" transform="translate(-1367 -40) translate(1367 40) translate(1 1)"/>
            </g>
        </svg>
    )
}